import { observer } from 'mobx-react';
import React from 'react';
import classnames from 'classnames';

import './styles.scss';

type PropsType = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
    aside?: () => React.ReactNode;
    className?: string;
};

export const UiModalTitle = observer(function UiModalTitle({ children, aside, className, style }: PropsType) {
    return <div className={classnames('ui-new-modal-title', className)} style={style}>
        <div className="ui-new-modal-title__inner">{children}</div>
        {!!aside && (
            <div className="ui-new-modal-title__aside">{aside()}</div>
        )}
    </div>;
});
